import * as assert from 'assert';
import { INewCollection, IServerCollection, ServerCollection } from '../_interfaces/Collection';
import { CrudService } from './CrudService';

export class CollectionService extends CrudService<ServerCollection, INewCollection, Partial<INewCollection>> {
    protected basePath = 'collections';
    protected subPaths = {
        artifacts: 'artifacts'
    };

    public create(newRecord: INewCollection): Promise<number> {
        console.assert(newRecord, 'Paramater is undefined');

        return super.create(newRecord).then((id) => {
            console.assert(typeof id === 'number', `error in response when creating new collection, id: ${id} was returned as not a number`);
            return id as number;
        });
    }

    public getCollectionArtifactIds(id: number | string): Promise<Array<number>> {
        console.assert(id, 'Paramater is undefined');

        return this.getSubPath(id.toString() + '/' + this.subPaths.artifacts).then((response: Array<number>) => {
            assert(Array.isArray(response), 'unexpected response format when getting collection artifacts');
            return response;
        });
    }

    public addArtifactToCollection(collection_id: number, artifact_id: number): Promise<any> {
        return this.postSubPath(`${collection_id}/${this.subPaths.artifacts}`, { artifact_id });
    }

    public removeArtifactFromCollection(collection_id: number, artifact_id: number): Promise<any> {
        return this.deleteSubPath(`${collection_id}/${this.subPaths.artifacts}`, { artifact_id });
    }

    protected assembleInstances(response: Array<IServerCollection>): Array<ServerCollection> {
        const out: Array<ServerCollection> = [];

        response.forEach((record) => {
            const validArtifact: ServerCollection = this.assembleSingleInstance(record);
            out.push(validArtifact);
        });

        return out;
    }

    protected assembleSingleInstance(response: IServerCollection): ServerCollection {
        return new ServerCollection(response);
    }
}



// WEBPACK FOOTER //
// ./src/_services/CollectionService.ts